import * as React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import type { BrandListItem } from "src/api/brand/brandApi";

type Props = {
  list: BrandListItem[];
  loading: boolean;
  disabled?: boolean;
  onEdit: (item: BrandListItem) => void;
  onDelete: (item: BrandListItem) => void;
};

export default function BrandTable({ list, loading, disabled = false, onEdit, onDelete }: Props) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell width={80}>ID</TableCell>
          <TableCell>브랜드명</TableCell>
          <TableCell width={140}>카테고리</TableCell>
          <TableCell width={90}>활성</TableCell>
          <TableCell width={90}>추천</TableCell>
          <TableCell width={110}>노출순서</TableCell>
          <TableCell width={190}>생성일</TableCell>
          <TableCell width={120} align="right">
            액션
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {list.map((it) => (
          <TableRow key={it.id} hover>
            <TableCell>{it.id}</TableCell>
            <TableCell sx={{ fontWeight: 900 }}>
              {it.brandNameKo ?? "-"}
              <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
                {it.brandNameEn ?? ""}
              </Typography>
            </TableCell>
            <TableCell>{it.brandCategoryName ?? it.brandCategoryId ?? "-"}</TableCell>
            <TableCell>{it.isActive ? "Y" : "N"}</TableCell>
            <TableCell>{it.isFeatured ? "Y" : "N"}</TableCell>
            <TableCell>{Number.isFinite(it.displayOrder) ? it.displayOrder : "-"}</TableCell>
            <TableCell>{it.createdAt ? new Date(it.createdAt).toLocaleString() : "-"}</TableCell>
            <TableCell align="right">
              <IconButton size="small" onClick={() => onEdit(it)} disabled={disabled || loading}>
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" onClick={() => onDelete(it)} disabled={disabled || loading}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}

        {list.length === 0 ? (
          <TableRow>
            <TableCell colSpan={8} align="center" sx={{ py: 6, color: "text.secondary" }}>
              데이터가 없습니다.
            </TableCell>
          </TableRow>
        ) : null}
      </TableBody>
    </Table>
  );
}
